import { useEffect, useRef, useState } from 'react';

export default function ChromeWordmark({ className = '', label, src }) {
  const imageRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const image = imageRef.current;
    if (image?.complete && image.naturalWidth > 0) setLoaded(true);
  }, [src]);

  return (
    <span
      className={`chrome-wordmark ${className}${loaded ? ' is-loaded' : ''}`}
      role="img"
      aria-label={label}
    >
      <span className="chrome-wordmark__fallback" aria-hidden="true">{label}</span>
      <img
        ref={imageRef}
        className="chrome-wordmark__art"
        src={src}
        alt=""
        aria-hidden="true"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(false)}
      />
    </span>
  );
}
